import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { FaEnvelope, FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import { UserContext } from '../Controllers/UserContext';
import './HarvestProductDetails.css';
import Breadcrumb from '../Components/Breadcrumb';
import Variables from '../Variables.json';



import { Helmet } from 'react-helmet-async';

export default function HarvestProductDetails() {

    const formatDescription = (text) => {
        if (!text) return "";

        // 1. Replace *text* with <strong>text</strong>
        let formattedText = text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");

        // 2. Replace double line breaks with <p> tags for paragraphs
        formattedText = formattedText.split(/\n\s*\n/).map(paragraph => `<p>${paragraph}</p>`).join('');

        // 3. Optionally replace single line breaks inside paragraph with <br>
        formattedText = formattedText.replace(/\n/g, "<br>");

        return formattedText;
    };


    const { ProductId } = useParams();
    const { setCartItems, cartItems } = useContext(UserContext);

    const [productData, setProductData] = useState(null);
    const [productImages, setProductImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(true);

    // Magnifier State
    const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });
    const [showZoom, setShowZoom] = useState(false);
    const [zoomStyle, setZoomStyle] = useState({});

    const IMAGE_BASE_URL = Variables.baseUrl;

    useEffect(() => {
        if (ProductId) fetchProductDetails();
    }, [ProductId]);

    const fetchProductDetails = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${IMAGE_BASE_URL}/api/HarvestFarms/Products/GetById`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ProductId: Number(ProductId) })
                }
            );

            const result = await response.json();
            setProductData(result);

            if (Array.isArray(result.Images)) {
                const imgs = result.Images
                    .map(img => {
                        const rawUrl = img?.Url;
                        if (!rawUrl) return null;

                        if (typeof rawUrl === "string" && rawUrl.startsWith("http")) return rawUrl;
                        if (typeof rawUrl === "string" && rawUrl.startsWith("/")) return IMAGE_BASE_URL + rawUrl;

                        try {
                            const parsed = JSON.parse(rawUrl);
                            if (parsed?.Url) return parsed.Url;
                        } catch { }

                        return null;
                    })
                    .filter(Boolean);

                setProductImages(imgs);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddToCart = () => {
        if (!productData) return;

        const exists = cartItems.some(item => item.ProductId === productData.ProductId);

        if (!exists) {
            setCartItems(prev => [
                ...prev,
                {
                    ProductId: productData.ProductId,
                    ProductName: productData.ProductName,
                    Price: productData.PricePerUnit,
                    Quantity: quantity,
                    Image: productImages[0]
                }
            ]);
            alert('Product added to cart!');
        } else {
            alert('Product already in cart!');
        }
    };

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.pageX - left - window.scrollX) / width) * 100;
        const y = ((e.pageY - top - window.scrollY) / height) * 100;

        setZoomPos({ x, y });
        setZoomStyle({
            backgroundPosition: `${x}% ${y}%`,
            backgroundImage: `url(${productImages[selectedImage] || "/placeholder.jpg"})`
        });
    };

    const handleMouseEnter = () => setShowZoom(true);
    const handleMouseLeave = () => setShowZoom(false);

    if (loading) return <div className="ykp-loading">Loading...</div>;
    if (!productData) return <div className="ykp-error">Product not found</div>;

    return (
        <>
            <Breadcrumb productName={productData.ProductName} />
            <div className="container">
            {productData && (
                <Helmet>
                    <title>{`${productData.ProductName} | YK Mart Harvest`}</title>
                    <meta name="description" content={`Buy fresh ${productData.ProductName} from ${productData.FarmName} at YK Mart. Origin: ${productData.OriginCity}. Harvested on ${productData.HarvestDate}.`} />
                    <meta property="og:title" content={`${productData.ProductName} - Fresh from ${productData.FarmName} | YK Mart`} />
                    <meta property="og:description" content={`Order farm-fresh ${productData.ProductName} on YK Mart. Origin: ${productData.OriginCity}. Supporting local organic farmers.`} />
                    <meta property="og:url" content={`https://ykmart.in/harvest-product/${ProductId}`} />
                    <meta property="og:image" content={productImages[0] || 'https://ykmart.in/logo.png'} />
                    <meta property="og:type" content="product" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:image" content={productImages[0] || 'https://ykmart.in/logo.png'} />
                </Helmet>
            )}
                <div className="product-details-container bgtransparent">
                    <div className="productcardharvest medicard">
                        {/* <h1 className="product-title">{productData.ProductName}</h1> */}
                        <div class="title-section product-title">
                            <h2>{productData.ProductName}</h2>
                            <div className="ykp-contact-icons">
                                <a href="mailto:support@ykmart.com" className="ykp-icon email emailcol">
                                    <FaEnvelope />
                                </a>

                                <a
                                    href={`https://wa.me/?text=${encodeURIComponent(
                                        `https://ykmart.in/harvest-product/${ProductId}\n\n🌾 *${productData.ProductName}*\n📍 *Origin:* ${productData.OriginCity}\n🚜 *Farm:* ${productData.FarmName}\n\nFresh from the farm! Order now on *YK Mart*.`
                                    )}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="ykp-icon whatsapp whatupcol"
                                >
                                    <FaWhatsapp />
                                </a>

                                <a href="tel:+919999999999" className="ykp-icon call callcol">
                                    <FaPhoneAlt />
                                </a>
                            </div>
                        </div>
                        <div className="product-details-wrapper">
                            {/* IMAGE SECTION */}
                            <div className="productimagesection">
                                <div className="gallery-layout">
                                    {/* Thumbnail Gallery (Amazon Style - Sidebar on Left) */}
                                    <div className="thumbnail-gallery-sidebar">
                                        {productImages.map((img, index) => (
                                            <div
                                                key={index}
                                                className={`thumbnail-item ${selectedImage === index ? 'active' : ''}`}
                                                onMouseEnter={() => setSelectedImage(index)}
                                                onClick={() => setSelectedImage(index)}
                                            >
                                                <img
                                                    src={img}
                                                    alt={`Thumbnail ${index}`}
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    {/* Main Image with Zoom */}
                                    <div className="main-image-container">
                                        <div
                                            className="main-image-viewport"
                                            onMouseMove={handleMouseMove}
                                            onMouseEnter={handleMouseEnter}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <img
                                                src={productImages[selectedImage] || "/placeholder.jpg"}
                                                alt={productData.ProductName}
                                                className="display-image"
                                                onError={e => e.target.src = "/placeholder.jpg"}
                                            />
                                            {showZoom && (
                                                <div className="zoom-lens" style={{ left: `${zoomPos.x}%`, top: `${zoomPos.y}%` }}></div>
                                            )}
                                        </div>

                                        {/* Resulting Zoom Panel (Amazon Style) */}
                                        {showZoom && (
                                            <div className="zoom-result-panel" style={zoomStyle}></div>
                                        )}
                                    </div>
                                </div>

                                <div className="trust-badge">
                                    <a href="http://nhrdf.org/" target="_blank" rel="noopener"><img src={`${process.env.PUBLIC_URL}/assets/certificate/HarvestLogo/harvestlogoNHDRF.jpeg`} alt="NHDRF Certificate" className="certificate-image" /></a>
                                    <a href="https://niphm.gov.in/" target="_blank" rel="noopener"><img src={`${process.env.PUBLIC_URL}/assets/certificate/HarvestLogo/harvestlogoNIPHM.jpg`} alt="NIPHM Certificate" className="certificate-image" /></a>
                                </div>
                            </div>

                            {/* PRODUCT INFO */}
                            <div className="product-info-section">
                                <h1 className="product-title">{productData.ProductName}</h1>

                                <div className="product-details-grid">
                                    <div className="detail-row">
                                        <span className="detail-label">Farm:</span>
                                        <span className="detail-value">{productData.FarmName}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Origin:</span>
                                        <span className="detail-value">{productData.OriginCity}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Harvest Date:</span>
                                        <span className="detail-value">{productData.HarvestDate}</span>
                                    </div>
                                </div>


                                <div className="description-section">
                                    <h3>Description</h3>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: formatDescription(productData.Description)
                                        }}
                                    />
                                </div>


                            </div>
                            <div className="down-social-icons">
                                <div className="socialiconsticky">
                                    <a href="mailto:support@ykmart.com" className="ykp-icon email borleft12">
                                        <FaEnvelope /> <span>E-mail</span>
                                    </a>
                                    <a
                                        href={`https://wa.me/?text=${encodeURIComponent(
                                            `https://ykmart.in/harvest-product/${ProductId}\n\n🌾 *${productData.ProductName}*\n📍 *Origin:* ${productData.OriginCity}\n🚜 *Farm:* ${productData.FarmName}\n\nFresh from the farm! Order now on *YK Mart*.`
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ykp-icon whatsapp"
                                    >
                                        <FaWhatsapp /> <span> WhatsApp</span>
                                    </a>

                                    <a href="tel:+919999999999" className="ykp-icon call borright12">
                                        <FaPhoneAlt /> <span>Call</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                <div className="ykp-contact-icons">
                    <a href="mailto:support@ykmart.com" className="ykp-icon email emailcol">
                        <FaEnvelope />
                    </a>

                    <a
                        href={`https://wa.me/?text=${encodeURIComponent(
                            `https://ykmart.in/harvest-product/${ProductId}\n\n🌾 *${productData.ProductName}*\n📍 *Origin:* ${productData.OriginCity}\n🚜 *Farm:* ${productData.FarmName}\n\nFresh from the farm! Order now on *YK Mart*.`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ykp-icon whatsapp whatupcol"
                    >
                        <FaWhatsapp />
                    </a>

                    <a href="tel:+919999999999" className="ykp-icon call callcol">
                        <FaPhoneAlt />
                    </a>
                </div>




            </div>
        </>
    );
}
